import type * as Types from 'app/types/graphql';

import {
  UsageFeeBillEdgeSelectFragmentDoc,
  UsageFeeBillSelectFragmentDoc,
} from '../fragments/usageFeeBill.generated';
import { ShopPlatformRevenueSelectFragmentDoc } from '../fragments/shopPlatformPlan.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type UsageFeeBillsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Array<Types.UsageFeeBillOrder>>;
  where?: Types.InputMaybe<Types.UsageFeeBillWhereInput>;
}>;

export type UsageFeeBillsQueryResponse = {
  usageFeeBills?: Types.Maybe<
    Pick<Types.UsageFeeBillConnection, 'totalCount'> & {
      edges?: Types.Maybe<
        Array<
          Pick<Types.UsageFeeBillEdge, 'cursor'> & {
            node?: Types.Maybe<
              Pick<
                Types.UsageFeeBill,
                | 'id'
                | 'cycleStartDate'
                | 'cycleEndDate'
                | 'status'
                | 'price'
                | 'usageAmount'
                | 'paidAt'
              > & {
                revenue?: Types.Maybe<
                  Pick<Types.ShopPlatformRevenue, 'id' | 'date' | 'totalRevenue'>
                >;
                shopPlatformPlan?: Types.Maybe<Pick<Types.ShopPlatformPlan, 'id' | 'planID'>>;
              }
            >;
          }
        >
      >;
      pageInfo: Pick<
        Types.PageInfo,
        'startCursor' | 'endCursor' | 'hasNextPage' | 'hasPreviousPage'
      >;
    }
  >;
};

export const UsageFeeBillsDocument = `
    query UsageFeeBills($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: [UsageFeeBillOrder!], $where: UsageFeeBillWhereInput) {
  usageFeeBills(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    ...UsageFeeBillEdgeSelect
  }
}
    ${UsageFeeBillEdgeSelectFragmentDoc}
${UsageFeeBillSelectFragmentDoc}
${ShopPlatformRevenueSelectFragmentDoc}`;

export const useUsageFeeBillsQuery = <TData = UsageFeeBillsQueryResponse, TError = unknown>(
  variables?: UsageFeeBillsQueryVariables,
  options?: UseQueryOptions<UsageFeeBillsQueryResponse, TError, TData>,
) => {
  return useQuery<UsageFeeBillsQueryResponse, TError, TData>(
    variables === undefined ? ['UsageFeeBills'] : ['UsageFeeBills', variables],
    appFetcher<UsageFeeBillsQueryResponse, UsageFeeBillsQueryVariables>(
      UsageFeeBillsDocument,
      variables,
    ),
    options,
  );
};

useUsageFeeBillsQuery.getKey = (variables?: UsageFeeBillsQueryVariables) =>
  variables === undefined ? ['UsageFeeBills'] : ['UsageFeeBills', variables];
